export default "__VITE_ASSET__LuPHGglX__"